import {
    TextHelper,
    //SmallTextHelper,
    UrlHelper,
    //ArrayHelper
} from '../PrismicHelpers';

export const myDownloadsPageHelper = (response) => {

    const myDownloadsData = response.results[0].data;

    let dataToSend = {
        documents: myDownloadsData.documents && myDownloadsData.documents.length > 0 ?
            myDownloadsData.documents.map(document => {
                return {
                    document_url: UrlHelper(document.document_url),
                    title: TextHelper(document.title),
                    image: UrlHelper(document.image),
                }
            })
            : null
    };

    return dataToSend
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/MyDownloadsHelpers.js